/**
 * MemberDetailsInternalService
 * Member contact lists and custom fields BY KEY for other services (membermanagement 003).
 * Route: api/internal/members (X-API-Key)
 * Controller: Internal/MemberDetailsInternalController.cs
 *
 * For server-side callers only (an HttpClient configured with an apiKey, or pass the header per call).
 * Built-in member fields are written through api/internal/members/{id}/apply-fields.
 */
import { BaseService } from '../base/BaseService';
export class MemberDetailsInternalService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MemberDetailsInternalService.DEFAULT_SERVICE_PATH,
            basePath: MemberDetailsInternalService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET field-catalogue: built-in fields, contact lookups and custom field definitions. */
    async getFieldCatalogue(includeInactive = false, options) {
        const res = await this.http.get(this.buildUrlWithParams(this.getEndpoint('fieldCatalogue', 'field-catalogue'), { includeInactive }), options);
        if (!res.data)
            throw new Error('Failed to load the member field catalogue');
        return res.data;
    }
    /** GET {id}/contact-points */
    async getContactPoints(memberId, options) {
        const res = await this.http.get(this.buildUrl(this.getEndpoint('contactPoints', `${memberId}/contact-points`)), options);
        return res.data ?? [];
    }
    /** POST contact-points/batch: up to 1000 members (memberID → list). */
    async getContactPointsBatch(memberIDs, options) {
        const res = await this.http.post(this.buildUrl(this.getEndpoint('contactPointsBatch', 'contact-points/batch')), { memberIDs }, options);
        return res.data ?? {};
    }
    /** GET contact-points/find: member ids with this phone (any form) or email on their list. kindId 1 phone, 2 email. */
    async findMembersByContact(kindId, value, options) {
        const res = await this.http.get(this.buildUrlWithParams(this.getEndpoint('contactPointsFind', 'contact-points/find'), { kindId, value }), options);
        return res.data ?? [];
    }
    /** POST {id}/contact-points/apply: upsert phones and emails by value (audited). */
    async applyContactPoints(memberId, data, options) {
        const res = await this.http.post(this.buildUrl(this.getEndpoint('applyContactPoints', `${memberId}/contact-points/apply`)), data, options);
        if (!res.data)
            throw new Error('Failed to apply the contact details');
        return res.data;
    }
    /** GET {id}/custom-fields?keys=&includeSensitive= */
    async getCustomFields(memberId, keys, includeSensitive = false, options) {
        const res = await this.http.get(this.buildUrlWithParams(this.getEndpoint('customFields', `${memberId}/custom-fields`), {
            keys: keys && keys.length > 0 ? keys.join(',') : undefined,
            includeSensitive,
        }), options);
        if (!res.data)
            throw new Error('Failed to load the member fields');
        return res.data;
    }
    /** POST custom-fields/batch: up to 1000 members (memberID → fields). */
    async getCustomFieldsBatch(memberIDs, fieldKeys, includeSensitive = false, options) {
        const res = await this.http.post(this.buildUrl(this.getEndpoint('customFieldsBatch', 'custom-fields/batch')), { memberIDs, fieldKeys, includeSensitive }, options);
        return res.data ?? {};
    }
    /** POST {id}/custom-fields/apply: set member fields by key (audited). */
    async applyCustomFields(memberId, data, options) {
        const res = await this.http.post(this.buildUrl(this.getEndpoint('applyCustomFields', `${memberId}/custom-fields/apply`)), data, options);
        if (!res.data)
            throw new Error('Failed to apply the member fields');
        return res.data;
    }
}
MemberDetailsInternalService.DEFAULT_SERVICE_PATH = 'members';
MemberDetailsInternalService.BASE_PATH = 'api/internal/members';
//# sourceMappingURL=MemberDetailsInternalService.js.map